import { useEffect, useMemo, useState } from 'react';

const groupProcessesByType = (processes = [], allowWarmer = false) => {
  if (!Array.isArray(processes) || processes.length === 0) {
    return [];
  }

  const groups = new Map();

  processes.forEach((process) => {
    if (!process) {
      return;
    }
    const isAzucarGlass = Boolean(process.proceso_es_azucar_glass);
    const isWarmer = Boolean(process.proceso_es_warmer);
    if (isWarmer && !allowWarmer) {
      return;
    }
    const type = isAzucarGlass ? 'azucar_glass' : (isWarmer ? 'warmer' : process.proceso_tipo || 'articulos');
    if (!groups.has(type)) {
      groups.set(type, []);
    }
    groups.get(type).push(process);
  });

  const orderedTypes = ['articulos', 'recetas', 'azucar_glass', 'warmer'];
  const result = [];

  orderedTypes.forEach((type) => {
    if (groups.has(type)) {
      result.push({ type, processes: groups.get(type) });
      groups.delete(type);
    }
  });

  groups.forEach((value, key) => {
    result.push({ type: key, processes: value });
  });

  return result;
};

export const useProcessesSelection = (processes, options = {}) => {
  const { allowWarmer = false } = options;
  const [selection, setSelection] = useState(() => new Set());

  const sections = useMemo(
    () => {
      console.log('[useProcessesSelection] Grouping processes:', {
        processesCount: Array.isArray(processes) ? processes.length : 0,
        allowWarmer,
        processes
      });
      const result = groupProcessesByType(processes, allowWarmer);
      console.log('[useProcessesSelection] Grouped sections:', result);
      return result;
    },
    [processes, allowWarmer]
  );

  useEffect(() => {
    setSelection((prev) => {
      const next = new Set(prev);
      const allowedValues = new Set(
        sections.flatMap((section) => section.processes.map((item) => item.proceso))
      );
      Array.from(next).forEach((value) => {
        if (!allowedValues.has(value)) {
          next.delete(value);
        }
      });
      return next;
    });
  }, [sections]);

  const toggle = (value) => {
    setSelection((prev) => {
      const next = new Set(prev);
      if (next.has(value)) {
        next.delete(value);
      } else {
        next.add(value);
      }
      return next;
    });
  };

  const clearSelection = () => setSelection(new Set());

  return {
    sections,
    selection,
    toggle,
    clearSelection
  };
};
